import Script from 'next/script'
import { convertSocials } from './utils/embedded-utils'

export default function TinyMce({ content }) {
    const convertedWpEmbed = convertSocials(content)

    return (
        <div className='[&_p]:my-5 [&_h1]:my-5 [&_h2]:my-5 [&_h3]:my-5 [&_h4]:my-5'>
            <Script async src="https://platform.twitter.com/widgets.js" charset="utf-8" />
            <Script async src="//www.instagram.com/embed.js" />
            <Script async src="https://www.tiktok.com/embed.js" />
            { convertedWpEmbed }
        </div>
    )
}
